import { render, staticRenderFns } from "./MiningPropertiesPage.vue?vue&type=template&id=318e2ca5"
import script from "./MiningPropertiesPage.vue?vue&type=script&lang=js"
export * from "./MiningPropertiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports